module.exports = __webpack_public_path__ + "static/media/grey-drop-down-arrow.34b57a45.svg";